import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loading from '../Common/Loading';
import CustomAlert from '../Common/CustomAlert';
import go_n from '../Common/Images/go_n.gif';
import go_o from '../Common/Images/go_o.gif';
import back_n from '../Common/Images/back_n.gif';
import back_o from '../Common/Images/back_o.gif';
import continue_n from '../Common/Images/continue_n.gif';


const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;
const ROWS_PER_PAGE = 50;

interface FlagAlert {
    Schoolcode: string;
    FamilyCode: string;
    Login: string;
    Major: string;
    Properties: string;
    Minor: string;
    LName: string;
    FName: string;
    Address1: string;
    PostalCode: string;
    Phone: string;
    State: string;
    EnteredDate: string;
}

interface DropdownOption {
    label: string;
    value: string;
}

const styles = {
    body: {
        margin: '0px',
        fontFamily: 'Trebuchet MS, Arial, Helvetica, sans-serif',
        fontSize: '10pt',
        backgroundColor: 'white',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column' as const,
    },
    container: {
        padding: '5px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column' as const,
        overflow: 'hidden',
    },
    titleBar: {
        color: 'black',
        backgroundColor: 'aliceblue',
        padding: '8px',
        fontSize: 'large',
        fontFamily: 'Trebuchet MS',
        width: '100%',
        textAlign: 'center' as const,
        fontWeight: 'bold',
        border: '1px solid #80a0ff',
        borderBottom: '0px',
        boxSizing: 'border-box' as const,
    },
    filterRow: {
        fontFamily: 'Arial',
        fontSize: '12pt',
        padding: '10px 5px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap' as const,
        gap: '15px',
        backgroundColor: '#f9f9f9',
        border: '1px solid #80a0ff',
        marginBottom: '5px'
    },
    headerRow: {
        fontFamily: 'Arial',
        fontSize: '12pt',
        backgroundColor: '#c7ddfd',
        color: '#2859ac',
        height: '32px',
        textAlign: 'left' as const,
    },
    headerCell: {
        padding: '8px',
        borderRight: '1px solid white',
        borderBottom: '1px solid #80a0ff',
        textAlign: 'left' as const,
        whiteSpace: 'nowrap' as const,
        fontWeight: 'normal' as const,
    },
    row: {
        fontFamily: 'Arial',
        fontSize: '12pt',
        backgroundColor: 'white',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
        color: 'black',
    },
    altRow: {
        fontFamily: 'Trebuchet MS',
        fontSize: '12pt',
        backgroundColor: '#F4FAFF',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
        color: 'black',
    },
    selectedRow: {
        fontFamily: 'Trebuchet MS',
        fontSize: '12pt',
        backgroundColor: 'orange',
        color: 'White',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
    },
    cell: {
        padding: '8px',
        fontSize: '12pt',
        borderRight: '1px solid #80a0ff',
        fontFamily: 'Arial',
        whiteSpace: 'nowrap' as const,
    },
    paginationBar: {
        backgroundColor: '#c7ddfd',
        color: '#2859ac',
        fontFamily: 'Arial',
        fontSize: '12pt',
        fontWeight: 'bold' as const,
        textAlign: 'center' as const,
        padding: '8px',
        border: 'solid 1px #80A0FF',
        borderTop: 'solid 1px #80A0FF',
        width: '99%',
    },
    navLink: {
        textDecoration: 'none',
        color: '#003366',
        margin: '0 5px',
        cursor: 'pointer',
    },
    scrollableDiv: {
        flex: 1,
        overflow: 'auto',
        border: '1px solid #80a0ff',
        width: '100%',
        backgroundColor: 'white',
        textAlign: 'left' as const,
    }, dropdown: {
        fontFamily: 'Arial',
        fontSize: '12pt',
        border: 'solid 1px teal',
        padding: '2px',
        cursor: 'pointer',
        minWidth: '130px'
    }
};

const EL_FlagedAlertList: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [isGoHovered, setIsGoHovered] = useState(false);
    const [isBackHovered, setIsBackHovered] = useState(false);

    const [countries, setCountries] = useState<DropdownOption[]>([]);
    const [flagTypes, setFlagTypes] = useState<DropdownOption[]>([]);

    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [selectedFlagType, setSelectedFlagType] = useState<string>('');
    const [useDate, setUseDate] = useState<boolean>(false);

    const initFromDate = new Date();
    initFromDate.setMonth(initFromDate.getMonth() - 1);
    const [fromDate, setFromDate] = useState<string>(initFromDate.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState<string>(new Date().toISOString().split('T')[0]);

    const [alerts, setAlerts] = useState<FlagAlert[]>([]);
    const [showTable, setShowTable] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    const [alertInfo, setAlertInfo] = useState({ show: false, message: '' });
    const [statusMsg, setStatusMsg] = useState<{ text: string, color: string } | null>(null);

    useEffect(() => {
        const fetchDropdowns = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/get_flag_dropdowns`);
                const result = await response.json();
                if (result.status === 'success') {
                    setCountries(result.countries);
                    setFlagTypes([{ label: '--Select--', value: '' }, ...result.flag_types]);
                    if (result.countries.length > 0) {
                        setSelectedCountry(result.countries[0].value);
                    }
                } else {
                    setStatusMsg({ text: result.message, color: 'red' });
                }
            } catch (error: any) {
                setStatusMsg({ text: "Network Error loading dropdowns", color: 'red' });
            } finally {
                setLoading(false);
            }
        };
        fetchDropdowns();
    }, []);

    const fetchAlerts = async () => {
        if (!selectedCountry) {
            setAlertInfo({ show: true, message: 'Please select a country.' });
            return;
        }

        setLoading(true);
        setShowTable(false);
        setStatusMsg(null);
        setSelectedRowIndex(null);

        try {
            const queryParams = new URLSearchParams({
                country: selectedCountry,
                flagType: selectedFlagType,
                useDate: String(useDate),
                fromDate: fromDate,
                toDate: toDate
            });

            const response = await fetch(`${API_BASE_URL}api/get_flags_and_alerts?${queryParams}`);
            const result = await response.json();

            if (result.status === 'success') {
                setAlerts(result.data);
                setCurrentPage(1);
                setShowTable(true);
            } else {
                setAlerts([]);
                setShowTable(false);
                setStatusMsg({
                    text: result.message || "Failed to load alerts",
                    color: 'red'
                });
            }
        } catch (error: any) {
            setStatusMsg({ text: error.message || "Network Error", color: 'red' });
        } finally {
            setLoading(false);
        }
    };

    const handleContinue = () => {
        if (selectedRowIndex === null) {
            setAlertInfo({ show: true, message: 'Please select a row to continue.' });
            return;
        }

        const selectedAlert = currentData[selectedRowIndex];

        const pageS = searchParams.get('S') || '';
        const pageF = searchParams.get('F') || '';
        const pageL = searchParams.get('L') || '';

        const queryParams = new URLSearchParams({
            SchoolCode: selectedAlert.Schoolcode,
            FamilyCode: 'A',
            Login: selectedAlert.Login,
            FilterType: 'CustEntry',
            S: pageS,
            F: pageF,
            L: pageL,
            Minor: selectedAlert.Minor,
            SelectedRow: String(selectedRowIndex + 1),
            ddlCountryState: selectedCountry,
            RowsperPage: String(ROWS_PER_PAGE),
            StartRecNo: String((currentPage - 1) * ROWS_PER_PAGE + 1)
        });

        navigate(`/SUPPORT/EL_AddEditTask?${queryParams.toString()}&CalledFrom=FlagedAlertList`);
    };

    const handleBack = () => {
        navigate('/SysAdmin');
    };

    const totalPages = Math.ceil(alerts.length / ROWS_PER_PAGE);
    const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
    const currentData = alerts.slice(startIndex, startIndex + ROWS_PER_PAGE);

    const handlePageChange = (direction: string) => {
        if (direction === 'first') setCurrentPage(1);
        if (direction === 'prev' && currentPage > 1) setCurrentPage(p => p - 1);
        if (direction === 'next' && currentPage < totalPages) setCurrentPage(p => p + 1);
        if (direction === 'last') setCurrentPage(totalPages);
        setSelectedRowIndex(null);
    };

    return (
        <div style={styles.body}>
            <div style={styles.container}>
                <div style={styles.titleBar}>
                    FLAGS AND ALERTS
                </div>

                <div style={styles.filterRow}>
                    <div>
                        Country&nbsp;:&nbsp;
                        <select
                            style={styles.dropdown}
                            value={selectedCountry}
                            onChange={(e) => setSelectedCountry(e.target.value)}
                        >
                            {countries.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                        </select>
                    </div>
                    <div>
                        Flags Type&nbsp;:&nbsp;
                        <select
                            style={{ ...styles.dropdown, minWidth: '270px' }}
                            value={selectedFlagType}
                            onChange={(e) => setSelectedFlagType(e.target.value)}
                        >
                            {flagTypes.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                        </select>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <input
                            type="checkbox"
                            id="chkDate"
                            checked={useDate}
                            onChange={(e) => setUseDate(e.target.checked)}
                        />
                        <label htmlFor="chkDate">Date</label>
                        &nbsp;&nbsp;From:
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            disabled={!useDate}
                        />
                        &nbsp;&nbsp;To:
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            disabled={!useDate}
                        />
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '15px', alignItems: 'center' }}>
                        <img
                            src={isGoHovered ? go_o : go_n}
                            alt="Go"
                            onClick={fetchAlerts}
                            onMouseEnter={() => setIsGoHovered(true)}
                            onMouseLeave={() => setIsGoHovered(false)}
                            style={{ cursor: 'pointer' }}
                        />
                        <img
                            src={isBackHovered ? back_o : back_n}
                            alt="Back"
                            onClick={handleBack}
                            onMouseEnter={() => setIsBackHovered(true)}
                            onMouseLeave={() => setIsBackHovered(false)}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
                {statusMsg && (
                    <div style={{ textAlign: 'center', color: statusMsg.color, fontWeight: 'bold', marginBottom: '5px' }}>
                        {statusMsg.text}
                    </div>
                )}

                {loading && (
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '100px'
                        }}
                    >
                        <Loading />
                    </div>
                )}
                {showTable && (

                    <div style={styles.scrollableDiv}>
                        <table
                            cellPadding={0}
                            cellSpacing={0}
                            style={{
                                borderCollapse: 'collapse',
                                display: 'inline-table',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                <tr style={styles.headerRow}>
                                    {/* <th style={styles.headerCell}>SchoolCode</th> */}
                                    <th style={styles.headerCell}>Login</th>
                                    <th style={styles.headerCell}>Flag</th>
                                    <th style={{ ...styles.headerCell }}>Description</th>
                                    <th style={styles.headerCell}>Surname</th>
                                    <th style={styles.headerCell}>Student</th>
                                    <th style={styles.headerCell}>Address</th>
                                    <th style={styles.headerCell}>PostCode</th>
                                    <th style={styles.headerCell}>Phone</th>
                                    <th style={styles.headerCell}>State</th>
                                    <th
                                        style={{
                                            ...styles.headerCell,
                                            width: '100%'
                                        }}
                                    >
                                        EnteredDate
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={11} style={{ padding: '10px', textAlign: 'center' }}><Loading /></td></tr>
                                ) : (
                                    currentData.map((row, index) => {
                                        const isSelected = selectedRowIndex === index;
                                        let rowStyle = index % 2 === 0 ? styles.altRow : styles.row;
                                        if (isSelected) rowStyle = styles.selectedRow;

                                        return (
                                            <tr
                                                key={`${row.Schoolcode}-${row.Login}-${index}`}
                                                style={rowStyle}
                                                onClick={() => setSelectedRowIndex(index)}
                                            >
                                                {/* <td style={styles.cell}>{row.Schoolcode}</td> */}
                                                <td style={styles.cell}>{row.Login}</td>
                                                <td style={styles.cell}>{row.Major}</td>
                                                <td style={styles.cell}>{row.Properties}</td>
                                                <td style={styles.cell}>{row.LName}</td>
                                                <td style={styles.cell}>{row.FName}</td>
                                                <td style={styles.cell}>{row.Address1}</td>
                                                <td style={styles.cell}>{row.PostalCode}</td>
                                                <td style={styles.cell}>{row.Phone}</td>
                                                <td style={styles.cell}>{row.State}</td>
                                                <td
                                                    style={{
                                                        ...styles.cell,
                                                        width: '100%'
                                                    }}
                                                >
                                                    {row.EnteredDate
                                                        ? new Date(row.EnteredDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                        })
                                                        : ''}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                                {currentData.length === 0 && !loading && (
                                    <tr>
                                        <td colSpan={11} style={{ padding: '10px', textAlign: 'center', color: '#555' }}>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                )}

                {showTable && (

                    <div style={styles.paginationBar}>
                        <span style={styles.navLink} onClick={() => handlePageChange('first')}>&lt;&lt;</span>
                        <span style={styles.navLink} onClick={() => handlePageChange('prev')}>&lt;</span>
                        <span style={{ margin: '0 10px' }}>
                            {currentPage} of {totalPages || 1}
                        </span>
                        <span style={styles.navLink} onClick={() => handlePageChange('next')}>&gt;</span>
                        <span style={styles.navLink} onClick={() => handlePageChange('last')}>&gt;&gt;</span>
                    </div>
                )}


                {selectedRowIndex !== null && (
                    <div style={{ paddingTop: '10px', textAlign: 'center' }}>
                        <img src={continue_n} alt="Continue"
                            style={{ cursor: 'pointer' }}
                            onClick={handleContinue}
                        />
                    </div>
                )}

            </div>
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    onClose={() => setAlertInfo({ ...alertInfo, show: false })}
                />
            )}
        </div>
    );
}

export default EL_FlagedAlertList;